module.exports = __webpack_public_path__ + "img/chateau_vecquee_dessert.7fd2cad2.jpg";